/**
 * Formatação de números, tamanhos e coordenadas em pt-BR — utilitário OFICIAL
 * do projeto (todos os módulos devem usar estas funções).
 */

const nf0 = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 });
const nf1 = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 1 });

export function formatInt(n: number): string {
  return nf0.format(n);
}

/**
 * Tamanho em base decimal (1 MB = 1.000.000 bytes), pt-BR:
 * "850 B", "578 KB", "1,2 MB", "19 MB", "1,2 GB".
 */
export function formatBytes(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes < 0) return '—';
  if (bytes < 1000) return `${nf0.format(bytes)} B`;
  if (bytes < 1e6) return `${nf0.format(Math.max(1, Math.round(bytes / 1000)))} KB`;
  const mb = bytes / 1e6;
  if (mb < 10) return `${nf1.format(mb)} MB`;
  if (mb < 1000) return `${nf0.format(mb)} MB`;
  return `${nf1.format(mb / 1000)} GB`;
}

/** Número com `digits` casas decimais, pt-BR: formatDecimal(8.5, 1) → "8,5". */
export function formatDecimal(n: number, digits = 1): string {
  return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(n);
}

/** Duração: "0,4 s", "8,5 s", "42 s", "1 min 05 s", "1 h 02 min". */
export function formatDuration(ms: number): string {
  if (!Number.isFinite(ms) || ms < 0) return '—';
  const s = ms / 1000;
  if (s < 10) return `${formatDecimal(s, 1)} s`;
  if (s < 60) return `${Math.round(s)} s`;
  const total = Math.round(s);
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const sec = total % 60;
  if (h > 0) return `${h} h ${String(m).padStart(2, '0')} min`;
  return `${m} min ${String(sec).padStart(2, '0')} s`;
}

/** "3,120° S · 60,025° O" */
export function formatLonLat(lon: number, lat: number, digits = 3): string {
  const f = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: digits, maximumFractionDigits: digits });
  const ns = lat < 0 ? 'S' : 'N';
  const ew = lon < 0 ? 'O' : 'L';
  return `${f.format(Math.abs(lat))}° ${ns} · ${f.format(Math.abs(lon))}° ${ew}`;
}
